(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("vertx-eventbus"));
	else if(typeof define === 'function' && define.amd)
		define(["vertx-eventbus"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("vertx-eventbus")) : factory(root["EventBus"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_96__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition